import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
// BrowserRouter wird hier nicht mehr benötigt, da AppRouterProvider dies intern managed

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {/* <BrowserRouter> BrowserRouter wurde entfernt */}
      <App />
    {/* </BrowserRouter> */}
  </React.StrictMode>,
); 